<template>
    <label class="input" :class="{ hasError: v.$error }">
        <input
            type="tel"
            class="input input__text input__bigger"
            :placeholder="placeholder"
            v-model="phone"
        />
        <span class="input__error" v-if="v.$error">Укажите телефон</span>
    </label>
</template>

<script>
import Inputmask from "inputmask";

export default {
    name: "customPhone",
    components: { Inputmask },
    props: {
        value: {
            type: String,
            default: "",
        },
        v: {
            type: Object,
            required: true,
        },
        placeholder: {
            type: String,
            default: "Телефон",
        },
    },

    mounted() {
        let im = new Inputmask("+7 (999) 999 99 99").mask("[type='tel']");
    },

    computed: {
        phone: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            },
        },
    },
};
</script>
